





















































import {
  AnimationsAndTransitionsConfiguration,
  ChoiceAnswerView,
  TransitionStyle,
} from "@zoovu/runner-web-design-base";
import { Vue, Component, Prop, ComponentConfig, VueComponent } from "@zoovu/runner-browser-api";
import { hideHorizontalOverflow, restoreHorizontalOverflow } from "../services/overflow-service";
import { getTransitionName } from "../styles/abstract/transition";
import InvisibleWrapper from "./invisible-wrapper.vue";
import { AnswerAnimationStyleClass, getAnimationClass } from "../styles/abstract/animation";

@Component({
  name: "ChoiceAnswerView",
  mixins: [ChoiceAnswerView],
})
export default class ChoiceAnswerViewExtended extends Vue {
  @ComponentConfig(AnimationsAndTransitionsConfiguration)
  animationsAndTransitionsConfiguration: AnimationsAndTransitionsConfiguration;

  @Prop()
  answerTextHeight: string;

  @Prop()
  imageHeight: string;

  transitionDelayEnabled = false;

  get answerIndex(): number {
    return this.answer.question.answers.indexOf(this.answer);
  }

  get answerWrapperStyle(): Record<string, string> {
    return {
      ...(this.transitionDelayEnabled ? { transitionDelay: `${this.answerIndex * 100}ms` } : {}),
      width: this.answerWrapperWidth,
    };
  }

  get answerWrapperWidth(): string {
    const numberOfAnswers = this.answer.question.answers.length;
    const maxAllowedAnswersPerRow = 4;
    const perRow = numberOfAnswers < maxAllowedAnswersPerRow ? numberOfAnswers : maxAllowedAnswersPerRow;
    const gutter = 15;
    return `calc( ${100 / perRow}% - ${gutter}px )`;
  }

  get doesSomeAnswerHaveInfoText(): boolean {
    return this.answer.question.answers.some((answer) => answer.hasInfoText);
  }

  get animationClass(): AnswerAnimationStyleClass {
    if (this.animationsAndTransitionsConfiguration.animationsEnabled) {
      return getAnimationClass(this.animationsAndTransitionsConfiguration.animationStyle.selected);
    }
    return AnswerAnimationStyleClass.NO_ANIMATION;
  }

  get selectedTransitionStyle(): TransitionStyle {
    return this.animationsAndTransitionsConfiguration.transitionStyle.selected;
  }

  get transitionComponent(): string | VueComponent {
    if (
      this.animationsAndTransitionsConfiguration.transitionsEnabled &&
      (this.selectedTransitionStyle === TransitionStyle.SLIDE_LEFT ||
        this.selectedTransitionStyle === TransitionStyle.FADE_AND_SLIDE_LEFT)
    ) {
      return "transition";
    }
    return InvisibleWrapper;
  }

  get transitionName(): string {
    if (this.animationsAndTransitionsConfiguration.transitionsEnabled) {
      return getTransitionName(this.selectedTransitionStyle);
    }
    return "";
  }

  disableTransitionDelay(): void {
    this.transitionDelayEnabled = false;
  }

  enableTransitionDelay(): void {
    this.transitionDelayEnabled = true;
  }

  onAfterEnter(): void {
    if (this.answerIndex === this.answer.question.answers.length - 1) {
      restoreHorizontalOverflow();
    }

    this.disableTransitionDelay();
  }

  onBeforeEnter(): void {
    if (this.answerIndex === 0) {
      hideHorizontalOverflow();
    }

    this.enableTransitionDelay();
  }
}
